export const getBaseUrl = (): string => {
  return import.meta.env.VITE_SITE_URL || 'http://localhost:5173';
};

export const calculateReadingTime = (post: {
  excerpt?: string;
  description?: string;
  content: string;
}): number => {
  const text = [
    post.excerpt || post.description || '',
    post.content.replace(/<[^>]*>/g, '')
  ].join('');
  
  const charCount = text.length;
  const minutes = Math.ceil(charCount / 600);
  return Math.max(1, minutes);
};

export const formatDate = (dateString: string): string => {
  const date = new Date(dateString);
  return date.toLocaleDateString('ja-JP', {
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  });
};

export const searchPosts = (posts: any[], query: string) => {
  if (!query.trim()) return posts;
  
  const lowerQuery = query.toLowerCase();
  
  return posts.filter(post => {
    const searchText = [
      post.title,
      post.excerpt || post.description || '',
      post.content?.replace(/<[^>]*>/g, '') || '',
      ...(Array.isArray(post.tags) ? post.tags : []),
      post.category_slug
    ].join(' ').toLowerCase();
    
    return searchText.includes(lowerQuery);
  });
};

/**
 * Supabase Storage の画像 URL を Image Transformation API 経由で配信するよう変換する。
 * - /storage/v1/object/public/ → /storage/v1/render/image/public/
 * - width / quality パラメータを付与してリサイズ・圧縮・WebP 自動変換を有効化
 * - Supabase 以外の URL はそのまま返す
 */
export function optimizeImageUrl(
  url: string | null | undefined,
  options: { width?: number; quality?: number } = {},
): string | undefined {
  if (!url) return undefined;

  const { width = 800, quality = 75 } = options;

  // Supabase Storage の object URL を render/image URL へ変換
  if (url.includes('/storage/v1/object/public/')) {
    const renderUrl = url.replace(
      '/storage/v1/object/public/',
      '/storage/v1/render/image/public/',
    );
    return `${renderUrl}?width=${width}&quality=${quality}`;
  }

  // その他の URL（Readdy.ai, 外部CDN等）はそのまま返す
  return url;
}
